import { UPDATE_THEME } from "../actionTypes";

const initialState = {
  backgroud: false,
};

export default function index(state = initialState, action) {
  switch (action.type) {
    case UPDATE_THEME: {
      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return state;
  }
}
